import React from "react";
import "./ServicesSection.scss";

export default function ServicesSection() {
  return (
    <section className="services-section" aria-labelledby="services-title">
      <div className="services-section__inner">
        <h2 id="services-title" className="services-section__title">
          Our Services
        </h2>

        <div className="services-grid">
          <article className="service-card">
            <h3 className="service-card__title">CCTV Sales & Installation</h3>
            <p className="service-card__desc">
              Analogue & IP camera installs (Dome, Bullet, PTZ).
            </p>
            <a
              className="service-card__cta"
              href={`https://wa.me/${"919538777965".replace(
                /[^\d]/g,
                ""
              )}?text=${encodeURIComponent(
                "Hi, I'm interested in your service."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Service →
            </a>
          </article>

          <article className="service-card">
            <h3 className="service-card__title">DVR / NVR Setup</h3>
            <p className="service-card__desc">
              Recording systems, storage sizing and configuration.
            </p>
            <a
              className="service-card__cta"
              href={`https://wa.me/${"919538777965".replace(
                /[^\d]/g,
                ""
              )}?text=${encodeURIComponent(
                "Hi, I'm interested in your service."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Service →
            </a>
          </article>

          <article className="service-card">
            <h3 className="service-card__title">Network Cameras (IP)</h3>
            <p className="service-card__desc">
              High-res IP cameras, PoE, remote viewing setup.
            </p>
            <a
              className="service-card__cta"
              href={`https://wa.me/${"919538777965".replace(
                /[^\d]/g,
                ""
              )}?text=${encodeURIComponent(
                "Hi, I'm interested in your service."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Service →
            </a>
          </article>

          <article className="service-card">
            <h3 className="service-card__title">Access Control</h3>
            <p className="service-card__desc">
              Biometric, RFID and card access systems.
            </p>
            <a
              className="service-card__cta"
              href={`https://wa.me/${"919538777965".replace(
                /[^\d]/g,
                ""
              )}?text=${encodeURIComponent(
                "Hi, I'm interested in your service."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Service →
            </a>
          </article>

          <article className="service-card">
            <h3 className="service-card__title">Intruder Alarms</h3>
            <p className="service-card__desc">
              Sensors, sirens and monitoring setup.
            </p>
            <a
              className="service-card__cta"
              href={`https://wa.me/${"919538777965".replace(
                /[^\d]/g,
                ""
              )}?text=${encodeURIComponent(
                "Hi, I'm interested in your service."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Service →
            </a>
          </article>

          <article className="service-card">
            <h3 className="service-card__title">Maintenance & Repair</h3>
            <p className="service-card__desc">
              Onsite servicing and troubleshooting.
            </p>
            <a
              className="service-card__cta"
              href={`https://wa.me/${"919538777965".replace(
                /[^\d]/g,
                ""
              )}?text=${encodeURIComponent(
                "Hi, I'm interested in your service."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Service →
            </a>
          </article>

          <article className="service-card">
            <h3 className="service-card__title">Networking</h3>
            <p className="service-card__desc">
              Onsite servicing and troubleshooting.
            </p>
            {/* <a className="service-card__cta" href={`https://wa.me/${+919538777965.replace(/[^\d]/g, "")}?text=${encodeURIComponent(
                    `Hi, I'm interested in: ${`Hi, I'm interested`}`
                  )}`} target="_blank" rel="noopener noreferrer"> Request Service →
            </a> */}
            <a
              className="service-card__cta"
              href={`https://wa.me/${"919538777965".replace(
                /[^\d]/g,
                ""
              )}?text=${encodeURIComponent(
                "Hi, I'm interested in your service."
              )}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Request Service →
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}
